<template>
  <v-container class="page mt-0 pt-0">
    <v-overlay :value="overlay">
      <v-progress-circular
        indeterminate
        size="64"
      />
    </v-overlay>
    <v-dialog
      v-model="showPhotoDialog"
      max-width="500"
      class="mx-auto"
    >
      <v-card v-if="!dontHavePhoto">
        <v-img
          :src="photoUrl"
        />
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="error"
            text
            @click="handleClosePhoto"
          >
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
      <v-card v-else>
        <v-card-title class="justify-center pa-10">
          <v-icon size="90">
            mdi-close-octagon
          </v-icon>
        </v-card-title>
        <v-card-title class="justify-center">
          No photo available
        </v-card-title>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="error"
            text
            @click="handleClosePhoto"
          >
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="successUser"
      max-width="500px"
    >
      <v-card
        dark
        color="green"
      >
        <v-card-title>
          <span v-if="icreateUser">
            <v-icon>mdi-check-circle</v-icon> Success create user!
          </span>
          <span v-else-if="iupdateUser">
            <v-icon>mdi-check-circle</v-icon> Success update user!
          </span>
          <span v-else-if="ideleteUser">
            <v-icon>mdi-check-circle</v-icon> User has been deleted!
          </span>
        </v-card-title>
        <v-card-actions>
          <v-spacer />
          <v-btn
            text
            @click="successUser = false"
          >
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-row
      class="d-flex justify-center"
      v-show="!overlay"
    >
      <v-col
        cols="12"
        sm="8"
        md="8"
      >
        <v-card
          elevation="0"
          v-show="!overlay"
          min-width="800"
          shaped
        >
          <div class=" text-center  px-10">
            <v-avatar
              color="primary"
              size="128"
              class="my-2"
            >
              <span class="white--text text-h5">{{ getFirstChar }}</span>
              <!-- <img
										v-if="havePhoto(editedItem)"
										:src="showPhoto"
									> -->
            </v-avatar>
            <h3>{{ editedItem.username }}</h3>
            <p class="text-title mt-1">
              {{ companyName }}
            </p>
            <v-chip
              small
              color="warning"
              class="font-weight-bold"
              v-if="editedItem.type == 1"
            >
              Admin
            </v-chip>
            <v-chip
              small
              color="primary"
              class="font-weight-bold"
              v-if="editedItem.type == 2"
            >
              User
            </v-chip>
            <v-chip
              small
              color="default"
              class="font-weight-bold"
              v-if="editedItem.type == 4"
            >
              HR Access
            </v-chip>
            <v-divider class="my-3" />
          </div>
          <v-alert
            v-model="isEmpty"
            type="error"
            dismissible
          >
            Please complete all fields
          </v-alert>
          <v-card-text v-if="page === 'showData'">
            <v-list
              two-line
              subheader
            >
              <v-subheader>Personal Information</v-subheader>
              <v-row>
                <v-col
                  cols="12"
                  sm="6"
                  md="6"
                >
                  <v-list-item>
                    <v-list-item-icon>
                      <v-icon color="indigo">
                        mdi-account
                      </v-icon>
                    </v-list-item-icon>

                    <v-list-item-content>
                      <v-list-item-subtitle>Full name</v-list-item-subtitle>
                      <v-list-item-title>{{ editedItem.first_name }} {{ editedItem.last_name }}</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>

                  <v-list-item>
                    <v-list-item-icon>
                      <v-icon color="indigo">
                        mdi-email
                      </v-icon>
                    </v-list-item-icon>

                    <v-list-item-content>
                      <v-list-item-subtitle>Email</v-list-item-subtitle>
                      <v-list-item-title>{{ editedItem.email }}</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-col>
                <v-col
                  cols="12"
                  sm="6"
                  md="6"
                >
                  <v-list-item>
                    <v-list-item-icon>
                      <v-icon color="indigo">
                        mdi-clock-time-five-outline
                      </v-icon>
                    </v-list-item-icon>

                    <v-list-item-content>
                      <v-list-item-subtitle>Timezone</v-list-item-subtitle>
                      <v-list-item-title>{{ editedItem.timezone }}</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>

                  <v-list-item>
                    <v-list-item-icon>
                      <v-icon color="indigo">
                        mdi-office-building-marker-outline
                      </v-icon>
                    </v-list-item-icon>

                    <v-list-item-content>
                      <v-list-item-subtitle>Company</v-list-item-subtitle>
                      <v-list-item-title>{{ companyName }}</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-col>
              </v-row>
              <v-divider class="my-3" />

              <v-subheader>Driver Licence Details</v-subheader>
              <v-row>
                <v-col
                  cols="12"
                  sm="6"
                  md="6"
                >
                  <v-list-item>
                    <v-list-item-icon>
                      <v-icon color="indigo">
                        mdi-card-account-details-outline
                      </v-icon>
                    </v-list-item-icon>

                    <v-list-item-content>
                      <v-list-item-subtitle>Licence Type</v-list-item-subtitle>
                      <v-list-item-title>{{ getLicenseType }} </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>

                  <v-list-item>
                    <v-list-item-action />
                    <v-list-item-content>
                      <v-list-item-subtitle>Licence Number</v-list-item-subtitle>
                      <v-list-item-title>{{ getLicenseNumber }}</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>

                  <v-list-item>
                    <v-list-item-action />
                    <v-list-item-content>
                      <v-list-item-subtitle>Conditions</v-list-item-subtitle>
                      <v-list-item-title>{{ getLicenseCondition }}</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-col>
                <v-col
                  cols="12"
                  sm="6"
                  md="6"
                >
                  <v-list-item>
                    <v-list-item-icon>
                      <v-icon color="indigo">
                        mdi-credit-card-clock-outline
                      </v-icon>
                    </v-list-item-icon>

                    <v-list-item-content>
                      <v-list-item-subtitle>Expired Date</v-list-item-subtitle>
                      <v-list-item-title>{{ getLicenseExpired }}</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>

                  <v-list-item>
                    <v-list-item-icon>
                      <v-icon color="indigo">
                        mdi-card-account-details-outline
                      </v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-subtitle>Issuing State</v-list-item-subtitle>
                      <v-list-item-title>{{ getLicenseState }}</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>

                  <v-list-item>
                    <v-list-item-icon>
                      <v-icon color="indigo">
                        mdi-image
                      </v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-subtitle>Licence Photo</v-list-item-subtitle>
                      <v-list-item-title>
                        <v-btn
                          small
                          outlined
                          color="primary"
                          @click="showPhoto()"
                        >
                          Show
                        </v-btn>
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-col>
              </v-row>
              <v-divider
                v-if="rfidRequired"
                class="my-3"
              />

              <v-subheader v-if="rfidRequired">
                Others
              </v-subheader>
              <v-row v-if="rfidRequired">
                <v-col
                  cols="12"
                  sm="6"
                  md="6"
                >
                  <v-list-item>
                    <v-list-item-icon>
                      <v-icon color="indigo">
                        mdi-card-text
                      </v-icon>
                    </v-list-item-icon>

                    <v-list-item-content>
                      <v-list-item-subtitle>RFID Type</v-list-item-subtitle>
                      <v-list-item-title>{{ getRFIDType }} </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-col>
                <v-col
                  cols="12"
                  sm="6"
                  md="6"
                >
                  <v-list-item>
                    <v-list-item-icon>
                      <v-icon color="indigo">
                        mdi-card-bulleted-outline
                      </v-icon>
                    </v-list-item-icon>

                    <v-list-item-content>
                      <v-list-item-subtitle>RFID Key</v-list-item-subtitle>
                      <v-list-item-title>{{ getRFIDKey }}</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-col>
              </v-row>
            </v-list>
          </v-card-text>
          <v-card-text
            class="my-0 px-10"
            v-if="page === 'form'"
          >
            <v-form
              ref="form"
              v-model="valid"
              lazy-validation
            >
              <v-alert
                v-model="emailCheck"
                type="error"
                dismissible
                class="my-0"
              >
                Email already used
              </v-alert>
              <v-row>
                <v-col
                  cols="12"
                  sm="6"
                >
                  <v-text-field
                    outlined
                    hide-details
                    color="success"
                    label="First Name"
                    v-model="editedItem.first_name"
                    :rules="firstnameRules"
                  />
                </v-col>
                <v-col
                  cols="12"
                  sm="6"
                >
                  <v-text-field
                    outlined
                    hide-details
                    color="success"
                    label="Last Name"
                    v-model="editedItem.last_name"
                    :rules="lastnameRules"
                  />
                </v-col>
                <!-- <v-col cols="12" sm="6" v-if="editedIndex === -1">
									<v-text-field
									outlined
									color="success"
									hide-details
									label="Username"
									v-model="editedItem.username"
									:rules="usernameRules"
									required
									></v-text-field>
							</v-col>
							<v-col cols="12" sm="6" v-if="editedIndex !== -1">
									<v-text-field
									outlined
									color="success"
									hide-details
									label="Username"
									v-model="editedItem.username"
									:rules="usernameRules"
									required
									disabled
									></v-text-field>
							</v-col>
							<v-col cols="12" sm="6" v-if="editedIndex === -1">
									<v-text-field
									outlined
									hide-details
									color="success"
									:type="showPassword ? 'text' : 'password'"
									label="Password"
									:append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
									@click:append="showPassword = !showPassword"
									v-model="editedItem.password"
									:rules="passwordRules"
									required
									></v-text-field>
							</v-col> -->
                <v-col
                  cols="12"
                  sm="12"
                >
                  <v-text-field
                    outlined
                    hide-details
                    color="success"
                    label="Email"
                    v-model="editedItem.email"
                    :rules="emailRules"
                    required
                  />
                </v-col>
                <v-col
                  cols="12"
                  sm="12"
                >
                  <v-combobox
                    hide-details
                    :items="dataTimezone"
                    item-text="value"
                    label="Timezone"
                    outlined
                    v-model="editedItem.timezone"
                  />
                </v-col>
                <v-col
                  cols="12"
                  sm="12"
                >
                  <v-select
                    hide-details
                    :items="rfid_types"
                    :item-text="(rfid_type) => `${rfid_type.name}`"
                    :item-value="(rfid_type) => `${rfid_type.name}`"
                    label="RFID Type"
                    outlined
                    v-model="editedItem.metadata.rfid_type"
                  />
                </v-col>
                <v-col
                  cols="12"
                  sm="12"
                  v-if="editedItem.metadata.rfid_type"
                >
                  <v-text-field
                    outlined
                    hide-details
                    color="success"
                    label="Key Cabinet RFID"
                    v-model="editedItem.metadata.key_cabinet_rfid"
                    :rules="keyRules"
                  />
                </v-col>
                <v-col
                  cols="12"
                  sm="12"
                >
                  <v-divider />
                </v-col>
                <v-col
                  sm="12"
                  class="font-weight-medium"
                >
                  Driver Licence Details
                </v-col>
                <v-col
                  cols="12"
                  sm="6"
                >
                  <v-text-field
                    outlined
                    hide-details
                    color="success"
                    label="Issuing state"
                    v-model="editedItem.metadata.driver_license.issuing_state"
                    :rules="issuingStateRules"
                  />
                </v-col>
                <v-col
                  cols="12"
                  sm="6"
                >
                  <v-text-field
                    outlined
                    hide-details
                    color="success"
                    label="Licence type"
                    v-model="editedItem.metadata.driver_license.license_type"
                    :rules="licenseTypeRules"
                  />
                </v-col>
                <v-col
                  cols="12"
                  sm="6"
                >
                  <v-text-field
                    outlined
                    hide-details
                    color="success"
                    label="Conditions"
                    v-model="editedItem.metadata.driver_license.conditions"
                    :rules="conditionsRules"
                  />
                </v-col>
                <v-col
                  cols="12"
                  sm="6"
                >
                  <v-text-field
                    outlined
                    hide-details
                    color="success"
                    label="Licence no"
                    v-model="editedItem.metadata.driver_license.license_no"
                    :rules="licenseNoRules"
                  />
                </v-col>
                <v-col sm="12">
                  <v-menu
                    v-model="isOpenDate"
                    :close-on-content-click="false"
                    max-width="290px"
                    min-width="290px"
                  >
                    <template #activator="{ on, attrs }">
                      <v-text-field
                        :value="editedItem.metadata.driver_license.expiry_date"
                        outlined
                        clearable
                        label="Expiry date"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        @click:clear="date = null"
                        :rules="expiryDateRules"
                        hide-details
                      />
                    </template>
                    <v-date-picker
                      v-model="editedItem.metadata.driver_license.expiry_date"
                      @change="isOpenDate = false"
                    />
                  </v-menu>
                </v-col>
                <v-col sm="12">
                  <v-file-input
                    v-model="editedItem.metadata.photo"
                    label="Upload your licence photo"
                    outlined
                    hide-details
                    placeholder="Select your jpg or png photo"
                    type="file"
                  />
                  <div
                    class="v-messages theme--light error--text mt-1"
                    v-if="uploadPhotoRequired"
                  >
                    <div class="v-messages__wrapper">
                      <div class="v-messages__message">
                        Please Complete Field
                      </div>
                    </div>
                  </div>
                </v-col>
                <v-col
                  cols="12"
                  sm="12"
                >
                  <v-divider />
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
          <v-divider />
          <v-card-actions
            v-if="page === 'form' "
            class="my-0 px-10"
          >
            <v-spacer />
            <v-btn
              @click="save"
              type="submit"
              color="success"
              to="/my_profile"
              :loading="loadingUpdate"
              :disabled="loadingUpdate"
            >
              SUBMIT
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import get from "lodash/get";
import isEmpty from "lodash/isEmpty";
import moment from "moment";
import axios from 'axios'

const qs = require("qs");
export default {
  data: () => ({
    token: "",
    clientid: "",
    isEmpty: false,
    valid: false,
    overlay: false,
    editedItem: {
      username: "",
      password: "",
      clientid: "",
      email: "",
      first_name: "",
      last_name: "",
      type: "",
      timezone: "",
      metadata: {
        vehicle_type: [],
        rfid_type: "",
        key_cabinet_rfid: "",
        key_cabinet_rfid_bin: "",
        user_manage: [],
        as_manager: false,
        driver_license: {
          issuing_state: "",
          license_type: "",
          conditions: "",
          license_no: "",
          expiry_date: "",
        },
        upload_photo: "",
      },
		},
		firstnameRules: [(v) => !!v || "First name is required"],
		lastnameRules: [(v) => !!v || "Last name is required"],
    emailRules: [(v) => !!v || "Email is required"],
    keyRules: [(v) => !!v || "Key Cabinet RFID is required"],
		issuingStateRules: [(v) => !!v || "Issuing state is required"],
    licenseTypeRules: [(v) => !!v || "Licence type is required"],
    conditionsRules: [(v) => !!v || "Conditions is required"],
    licenseNoRules: [(v) => !!v || "Licence no is required"],
    expiryDateRules: [(v) => !!v || "Expiry date is required"],
		rfid_types: [
      {
        name: 'RFID Card'
      },
      {
        name: 'RFID Key Ring'
      },
      {
        name: 'RFID Sticker'
      }
		],
		isOpenDate: false,
		photoUrl: "",
		dataTimezone: [],
		uploadPhotoRequired: false,
		editProfilButton: true,
		page: "showData",
		loadingUpdate: false,
		successUser: false,
    icreateUser: false,
    iupdateUser: false,
		ideleteUser: false,
		showPhotoDialog: false,
		dontHavePhoto: false,
    emailCheck: false,
  }),
  created() {
		this.token = this.$store.state.token;
		this.clientid = this.$store.state.clientid;
		let user_id = this.$store.state.user.user.id
		this.overlay = true;
		this.$store.dispatch('API_CALL', {
			$method: 'get_by_id',
			$postData: {
				id: user_id
			},
		})
		.then((response) => {
			this.editedItem = Object.assign({}, response.data.data);
			this.editedItem.metadata.as_manager = this.editedItem.metadata.as_manager == 'false' || this.editedItem.metadata.as_manager == false ? false : true;
      this.editedItem.metadata.rfid_type            = get(this.editedItem, 'metadata.rfid_type', "");
      this.editedItem.metadata.key_cabinet_rfid     = get(this.editedItem, 'metadata.key_cabinet_rfid', "");
      this.editedItem.metadata.key_cabinet_rfid_bin = get(this.editedItem, 'metadata.key_cabinet_rfid_bin', "");
      this.editedItem.metadata.user_manage          = get(this.editedItem, 'metadata.user_manage', []);
      this.editedItem.metadata.as_manager           = get(this.editedItem, 'metadata.as_manager', false);
      this.editedItem.metadata.driver_license = get(this.editedItem, 'metadata.driver_license', {});
      this.editedItem.metadata.driver_license.issuing_state =  get(this.editedItem, 'metadata.driver_license.issuing_state', "");
      this.editedItem.metadata.driver_license.license_type  =  get(this.editedItem, 'metadata.driver_license.license_type', "");
      this.editedItem.metadata.driver_license.conditions    =  get(this.editedItem, 'metadata.driver_license.conditions', "");
      this.editedItem.metadata.driver_license.license_no    =  get(this.editedItem, 'metadata.driver_license.license_no', "");
      this.editedItem.metadata.driver_license.expiry_date   =  get(this.editedItem, 'metadata.driver_license.expiry_date', "");
      this.editedItem.metadata.photo  =  get(this.editedItem, 'metadata.photo', "");

		});
	},
	computed: {
		companyName() {
      const companyData = this.$store.getters.getCompanyData;
      return companyData.name;
		},
		getLicenseType() {
			let license = ""
			license = get(this.editedItem.metadata, "driver_license.license_type", "")
			if(isEmpty(license)){
				license = "-"
				return license
			} else {
				return license
			}
			// return license;
		},
		getFirstChar() {
			let text = ""
			let text2 = ""
			text = get(this.editedItem, "first_name", "")
			text = text.charAt(0)
			text2 = get(this.editedItem, "last_name", "")
			if(isEmpty(text2)){
				text2 = "-"
				return `${text} ${text2}`;
			} else {
				text2 = text2.charAt(0)
				return `${text}${text2}`;
			}
				// return `${text.format("dddd, MMMM Do YYYY")}`;
		},
		getLicenseNumber() {
			let license = ""
			license = get(this.editedItem.metadata, "driver_license.license_no", "")
			if(isEmpty(license)){
				license = "-"
				return license
			} else {
				return license
			}
		},
		getLicenseCondition() {
			let license = ""
			license = get(this.editedItem.metadata, "driver_license.conditions", "")
			if(isEmpty(license)){
				license = "-"
				return license
			} else {
				return license
			}
		},
		getLicenseExpired() {
			let license = ""
			license = get(this.editedItem.metadata, "driver_license.expiry_date", "")
			if(isEmpty(license)){
				license = "-"
				return license
			} else {
				const start = moment(license, "YYYY-MM-DD");
				return `${start.format("D MMM YYYY")}`;
			}
		},
		getLicenseState() {
			let license = ""
			license = get(this.editedItem.metadata, "driver_license.issuing_state", "")
			if(isEmpty(license)){
				license = "-"
				return license
			} else {
				return license
			}
		},
		getRFIDType() {
			let text = ""
			text = get(this.editedItem.metadata, "rfid_type", "")
			if(isEmpty(text)){
				text = "-"
				return text
			} else {
				return text
			}
		},
		getRFIDKey() {
			let text = ""
			text = get(this.editedItem.metadata, "key_cabinet_rfid", "")
			if(isEmpty(text)){
				text = "-"
				return text
			} else {
				return text
			}
		},
    companyMetadata() {
      const companyData = this.$store.getters["getCompanyData"];
      return get(companyData, 'metadata', {});
    },
    rfidRequired() {
      const noNeedRFID = Boolean(get(this.companyMetadata, 'no_need_rfid', false));
      return !noNeedRFID;
    }
	},
  watch: {
    overlay(val) {
      val && setTimeout(() => {
        this.overlay = false
      }, 2e3)
		},
		upload_photo(value) {
      if (value !== [] || value.length !== 0) {
        this.uploadPhotoRequired = false;
      }
    },
  },
  mounted() {
    this.getTimezone();
    this.getDataDetail();
    this.getUsers();
  },
  methods: {
		getUsers() {
			this.$store.dispatch('API_CALL', {
					$method: 'get_all',
					$postData: {
						clientid: this.clientid,
					},
				})
				.then((response) => {
					this.loadingUser = false;
					this.dataApi = response.data.data.filter(
						(data) => data.status == 1 || data.status == 2
					);
				});
		},
		getDataDetail() {
			this.clientid = this.$store.state.clientid;
			let user_id = this.$store.state.user.user.id
			this.$store.dispatch('API_CALL', {
				$method: 'get_by_id',
				$postData: {
					id: user_id
				},
			})
			.then((response) => {
				this.editedItem = Object.assign({}, response.data.data);
				this.editedItem.metadata.photo  =  get(this.editedItem, 'metadata.photo', "");
				this.editedItem.email  =  get(this.editedItem, 'email', "");
			})
		},
		showPhoto() {
			let getPhoto = get(this.editedItem, "metadata.photo", "");

      this.showPhotoDialog = true;
      if(isEmpty(getPhoto)) {
        this.dontHavePhoto = true;
      } else {
        this.photoUrl = `${process.env.VUE_APP_API_URL}/${getPhoto}`;
      }
		},
		handleClosePhoto() {
      this.showPhotoDialog = false;
      this.dontHavePhoto = false;
    },
		// setInputTimezone($event) {
    //   this.editedItem.timezone = $event;
    // },
		save() {
      if (this.$refs.form.validate()) {
					this.loadingUpdate = true;
					this.loader = this.loadingUpdate;
					this.clientid = this.$store.state.clientid;
					this.token = this.$store.state.token;
					let user_id = this.$store.state.user.user.id
					this.ideleteUser = false;
					this.iupdateUser = false;
          this.icreateUser = false;
          let getTimezone = get(this.editedItem, "timezone", "");
          let checkTimezone = typeof getTimezone === "string" ? getTimezone : get(this.editedItem, "timezone.value", "");

          this.editedItem.timezone = checkTimezone;
					if (this.editedItem.metadata.photo) {
						const formData = new FormData();
						formData.append('token', this.token)
						formData.append('photo', this.editedItem.metadata.photo)
						formData.append('id', this.editedItem.id)
						formData.append('data', JSON.stringify(this.editedItem))

						return axios.post(`${process.env.VUE_APP_API_URL}/update_user`, formData).then((response) => {
							let respUpload = get(response.data.data, "driver_license_uploaded", {})
							let isErrorUpload = respUpload.success;
							let messageUpload = respUpload.message;
							if(response.data.code == 200 && isErrorUpload == true) {
								this.loadingUpdate = false;
								this.loader = this.loadingUpdate;
								this.closeModal();
								this.$swal({
									icon: 'success',
									title:  `${response.data.data.message} and ${messageUpload}`,
								})
								this.getDataDetail();
								// this.successUser = true;
								// this.iupdateUser = true;
								this.page = "showData";
								this.editProfilButton = true;
								this.emailCheck = false;
							} else if(response.data.code == 200 && isEmpty(respUpload)){
								this.loadingUpdate = false;
								this.loader = this.loadingUpdate;
								this.closeModal();
								this.$swal({
									icon: 'success',
									title:  `${response.data.data.message}`,
								})
								this.getDataDetail();
								// this.successUser = true;
								// this.iupdateUser = true;
								this.page = "showData";
								this.editProfilButton = true;
								this.emailCheck = false;

							} else if(response.data.code == 200 && !isErrorUpload){
								this.loadingUpdate = false;
								this.loader = this.loadingUpdate;
								this.closeModal();
								this.$swal({
									icon: 'error',
									title:  `Failed to update licence photo`,
									text:  `${messageUpload}`,
								})
								this.emailCheck = false;
							} else {
                this.loadingUpdate = false;
								this.loader = this.loadingUpdate;
								this.closeModal();
								this.$swal({
									icon: 'error',
									title:  response.data.data.message,
								})
								this.emailCheck = false;
              }
						});
					} else {
						this.$store.dispatch('API_CALL', {
								$method: 'update_user',
								$postData: {
									id: user_id,
									data: this.editedItem,
									clientid: this.clientid,
								},
							})
							.then((response) => {
								if(response.data.code == 200) {
									this.loadingUpdate = false;
									this.loader = this.loadingUpdate;
									this.closeModal();
									// this.successUser = true;
									// this.iupdateUser = true;
									this.$swal({
										icon: 'success',
										title: response.data.data.message,
									})
									this.page = "showData";
									this.editProfilButton = true;
									this.emailCheck = false;

								} else {
									this.$swal({
										icon: 'error',
										title: response.data.data.message,
									})
									this.emailCheck = false;
								}
							});
					}
			}
    },
		closeModal() {
      setTimeout(() => {
        this.$refs.form.resetValidation();
        // this.editedItem = Object.assign({}, this.defaultItem);
        this.dialog = false;
      }, 300);
    },
		getTimezone() {
			this.$store.dispatch('API_CALL', {
					$method: 'get_timezone',
				})
				.then((response) => {
					this.dataTimezone = response.data.data;
				});
		},
	},
};
</script>
